<template>
  <div class="legal-page formatted-privacy">
    <h1>Privacy Policy</h1>
    <p><strong>Last Updated:</strong> June 28, 2025</p>

    <p>
      This Privacy Policy explains how Pathtracer ("we", "our", or "us") collects, uses, and protects your information when you access or use our platform.
    </p>

    <hr />

    <h3>1. Information We Collect</h3>
    <ul>
      <li><strong>Registration Data:</strong> Name, email address, date of birth, country of residence, and intended use.</li>
      <li><strong>Log Data:</strong> IP address, browser type, device information, and usage timestamps.</li>
      <li><strong>Voluntary Info:</strong> Referral codes, agency affiliation, and other details you provide during signup or interaction.</li>
    </ul>

    <h3>2. How We Use Your Information</h3>
    <ul>
      <li>To create and manage user accounts.</li>
      <li>To improve service functionality and user experience.</li>
      <li>To respond to support inquiries or legal requests.</li>
      <li>To monitor suspicious activity and protect the platform from abuse.</li>
    </ul>

    <h3>3. Cookies and Analytics</h3>
    <p>
      We may use cookies and analytics tools to understand user behavior and improve our platform. You can manage cookie preferences via your browser settings.
    </p>

    <h3>4. Information Sharing</h3>
    <p>
      We do <strong>not</strong> sell or rent your personal information. We may share information with trusted service providers or authorities under the following circumstances:
    </p>
    <ul>
      <li>To comply with legal obligations or law enforcement requests.</li>
      <li>To enforce our Terms of Service or investigate potential violations.</li>
      <li>To maintain security and prevent abuse or fraud.</li>
    </ul>

    <h3>5. Data Security</h3>
    <p>
      We implement reasonable security measures to protect your personal data. However, no method of transmission over the internet is 100% secure.
    </p>

    <h3>6. Your Rights</h3>
    <ul>
      <li>You can request access to or correction of your personal data.</li>
      <li>You can request deletion of your account and associated data.</li>
      <li>We may retain limited information for legal or audit purposes.</li>
    </ul>

    <h3>7. Children's Privacy</h3>
    <p>
      Pathtracer is not intended for use by individuals under the age of 18. We do not knowingly collect personal information from children.
    </p>

    <h3>8. Updates to This Policy</h3>
    <p>
      We may update this Privacy Policy from time to time. When we do, we’ll update the date above and notify users of significant changes when applicable.
    </p>

    <h3>9. Contact Us</h3>
    <p>
      If you have any questions about this Privacy Policy, please contact us at
      <a href="mailto:support@pathtracer.io">support@pathtracer.io</a>.
    </p>

    <p><em>By using Pathtracer, you consent to the collection and use of your information as described in this Privacy Policy.</em></p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
};
</script>

<style scoped>
.legal-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 30px 20px;
  color: #333;
  font-size: 14px;
  line-height: 1.6;
}

.legal-page h1 {
  font-size: 24px;
  margin-bottom: 16px;
}

.legal-page h3 {
  margin-top: 24px;
  font-size: 16px;
  font-weight: bold;
}

.legal-page ul {
  padding-left: 20px;
  margin: 10px 0;
}

.legal-page ul li {
  margin-bottom: 6px;
}

.legal-page a {
  color: #3498db;
  text-decoration: underline;
}

.legal-page a:hover {
  color: #2980b9;
}
</style>
